module.exports = __webpack_public_path__ + "img/194.ed5777bb.jpg";